import { render, staticRenderFns } from "./tokenApproved.vue?vue&type=template&id=c16330b0&"
import script from "./tokenApproved.vue?vue&type=script&lang=js&"
export * from "./tokenApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports